import { ReactNode, useReducer } from "react";

import { DispatchContext, initialState, reducer, StateContext } from "./reducer";

interface DrawersProviderProps {
    children: ReactNode;
}

export function DrawersProvider({ children }: DrawersProviderProps) {
    const [state, dispatch] = useReducer(reducer, initialState);

    return (
        <StateContext.Provider value={state}>
            <DispatchContext.Provider value={dispatch}>{children}</DispatchContext.Provider>
        </StateContext.Provider>
    );
}
